<template>
<div class="shop-code">
    <input type="text"
        class="input-shop-code"
        :class="[ addClass , {'input-error':  filter.error} ]" 
        v-model="filter[config.key]"
        @input="onInput()"
        :placeholder="showText().placeholder"
    >
    <small class="text-error" v-if="filter[config.error]">{{showText().errorMsg}}</small>
</div>
</template>
<script>
import configPOPTheme from '@/config/POPTheme'
export default {
    props:{
        addClass: String,
        filter: Object,
        config: Object
    },
    methods:{
        showText(){
            let res = {
                placeholder: "ค้นหารหัสตัวแทนจำหน่าย",
                errorMsg:"กรุณากรอกรหัสตัวแทนจำหน่ายให้ถูกต้อง"
            }
            if( this.config.key == 'shop_code' ){
                res.placeholder = "ค้นหารหัสร้านค้า ("+ configPOPTheme.shopCodePrefix + "-000000)" 
                res.errorMsg = "กรุณากรอกรหัสร้านค้าให้ถูกต้อง"
            }
            return res
        },
        onInput(){
            let input = this.filter[this.config.key]
            if( this.checkInput() || input.length < 1){
                this.filter[this.config.error] = false
            }
            const value = event.target.value.toUpperCase();
            this.filter[this.config.key] = this.filter[this.config.key].replace(/^([A-Z]{2})-([0-9]{6})/gi, '$1-$2').toUpperCase();
            if (/^([A-Z]{2})-([0-9]{6})/gi.test(value)) {
                this.filter[this.config.key] = value.slice(0, 9);
                this.filter[this.config.error] = false
            }
            if (/^[A-Z]{2}$/.test(value)) {
                this.filter[this.config.key] = value + '-';
            } else if (/^[A-Z]{2}-[0-9]{6}$/.test(value)) {
                this.filter[this.config.key] = value;
            }
        },
        checkInput(){
            const patt = this.checkKey()
            let check = patt.test( this.filter[this.config.key] )

            if( this.filter[this.config.key].length > 0 && !check ){

                this.filter[this.config.error] = true
            }else{

                this.filter[this.config.error] = false
            }

            return check
        },
        checkKey(){
            let patt = /(^SA-)[0-9]{6}$/
            if( this.config.key == 'shop_code' ){
                patt = new RegExp('(^'+configPOPTheme.shopCodePrefix+'-)[0-9]{6}$')
            }
            return patt
        }
    }
}
</script>
<style scoped>
    .shop-code{
        width: 100%;
        position: relative;
    }
    .input-shop-code{
        width: 100%;
        border-radius: 5px;
    }
    .input-error{
        border-color: #fb6340;
    }
    .text-error{
        color: #fb6340;
    }
</style>